import { Button, Panel, Wrapper } from './Popover';
export const Popover = {
    Wrapper,
    Button,
    Panel,
};
//# sourceMappingURL=index.js.map